/**
 * Environment Configuration
 * Centralized environment variable management
 */

export const getEnvVar = (key, defaultValue = null) => {
  // Check for React environment variables (REACT_APP_*)
  const reactEnvKey = `REACT_APP_${key}`;
  const value = process.env[reactEnvKey] || process.env[key];
  
  if (value === undefined || value === null) {
    if (defaultValue !== null) {
      return defaultValue;
    }
    console.warn(`Environment variable ${key} is not set`);
    return null;
  }
  
  return value;
};

// API base URL: only from REACT_APP_API_URL (no fallback)
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || '',
  TIMEOUT: parseInt(getEnvVar('API_TIMEOUT', '10000'), 10),
  RETRY_ATTEMPTS: parseInt(getEnvVar('API_RETRY_ATTEMPTS', '3'), 10),
};

// Security Configuration
export const SECURITY_CONFIG = {
  ENABLE_ENCRYPTION: getEnvVar('ENABLE_ENCRYPTION', 'true') === 'true',
  ENABLE_PROTECTION: getEnvVar('ENABLE_PROTECTION', 'true') === 'true',
  ENABLE_DEVTOOLS_DETECTION: getEnvVar('ENABLE_DEVTOOLS_DETECTION', 'true') === 'true',
  SESSION_TIMEOUT: parseInt(getEnvVar('SESSION_TIMEOUT', '3600000'), 10), // 1 hour default
};

// Feature Flags
export const FEATURE_FLAGS = {
  ENABLE_ANALYTICS: getEnvVar('ENABLE_ANALYTICS', 'false') === 'true',
  ENABLE_DEBUG_MODE: getEnvVar('ENABLE_DEBUG_MODE', 'false') === 'true',
};

// Application Configuration
export const APP_CONFIG = {
  NAME: getEnvVar('APP_NAME', 'NTC Admin Dashboard'),
  VERSION: getEnvVar('APP_VERSION', '1.0.0'),
  ENVIRONMENT: process.env.NODE_ENV || 'development',
};

export default {
  API_CONFIG,
  SECURITY_CONFIG,
  FEATURE_FLAGS,
  APP_CONFIG,
  getEnvVar
};

